import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  propTypes as aggItemPropTypes,
  itemPropTypes
} from 'shared/proptypes/AggregationItem';
import { Checkbox, Radio } from 'shared/components/Form';
import { NOT_SPECIFIED_SLUG, TRANSLATED_TYPES, getTranslatedTypePath } from 'shared/constants';
import { SEARCH_PATHNAME_KEYS, getPathname } from 'shared/lib/jobSearchQuery';
import AggregationBox from './AggregationBox';
import styles from './AggregationBox.module.scss';

const FacetBox = ({
  type,
  title,
  multiselect,
  items,
  selected,
  searchItems,
  onSelect,
  maxPreviewItems,
  withSeoLinks,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = (e) => {
    e.preventDefault();
    setExpanded(prev => !prev);
  };

  const selectedSlugs = useMemo(() => selected.map(i => i.slug), [selected]);
  const selectedNotsMap = useMemo(() => selected.filter(i => i.not).reduce((acc, curr) => {
    acc[curr.slug] = curr.not;
    return acc;
  }, {}), [selected]);

  const getLabel = (itemSlug, itemTitle) => {
    if (type === 'suitableFor') {
      return t(`common:job.suitableFor.${itemSlug}`);
    }

    if (TRANSLATED_TYPES.includes(type)) {
      return t(getTranslatedTypePath(type, itemSlug));
    }

    if (type === 'city' || type === 'country') {
      if (itemSlug === NOT_SPECIFIED_SLUG) {
        return t('common:notSpecified');
      }

      if (!itemTitle) {
        return itemSlug.replace(/-/g, ' ');
      }
    }

    return itemTitle;
  };

  const getFacetQuery = (slug) => {
    if (!SEARCH_PATHNAME_KEYS.includes(type)) {
      return null;
    }

    return getPathname(searchItems.concat({ type, slug }));
  };

  const facetItems = Array.isArray(items)
    ? items
    : Object.entries(items).map(([slug, count]) => ({ slug: slug.toString(), count })).sort(item => item.slug ? -1 : 1);

  const facetElements = facetItems
    .map(item => ({ ...item, title: getLabel(item.slug, item.title) }))
    // TODO: optional prop pro abcedni razeni, defaultne off
    // .sort((a, b) => a.title.localeCompare(b.title))
    .sort((a, b) => b.slug === NOT_SPECIFIED_SLUG ? -1 : 0)
    .map(item => multiselect ? (
      <Checkbox
        fullWidth
        key={item.slug}
        label={<h5>{item.title} ({item.count})</h5>}
        name={type}
        id={`${type}-${item.slug}`}
        linkUrl={withSeoLinks && searchItems.length === 0 ? getFacetQuery(item.slug) : undefined}
        onClick={onSelect(item)}
        value={selectedSlugs.includes(item.slug)}
        inverse={selectedNotsMap[item.slug]}
      />
    ) : (
      <Radio
        fullWidth
        key={item.slug}
        label={<h5>{item.title} ({item.count})</h5>}
        name={type}
        id={`${type}-${item.slug}`}
        onClick={onSelect(item)}
        value={item.slug}
        checked={selectedSlugs.includes(item.slug)}
        inverse={selectedNotsMap[item.slug]}
      />
    ));

  const isCollapsedUsed = facetElements.some((elm, index) => (elm.props.value === true || elm.props.checked) && index + 1 > maxPreviewItems);

  return (
    <AggregationBox title={title}>
      <>
        {/*
        {items.filter((item) => {
          if (selectedSlugs.length === 0) {
            return item;
          }

          if (selectedSlugs.includes(item.slug)) {
            return item;
          }

          return item.count !== total;
        }).map(item => (
          <p key={item.slug}><input type="checkbox" id={`${type}-${item.slug}`} onClick={onSelect(item)} readOnly checked={selectedSlugs.includes(item.slug)} /><label htmlFor={`${type}-${item.slug}`}>{item.title} ({item.count})</label></p>
        ))}
        */}

        {facetElements.slice(0, maxPreviewItems)}
        {facetElements.length > maxPreviewItems && (
          <>
            <div className={expanded || isCollapsedUsed ? styles.expanded : styles.collapsed}>
              {facetElements.slice(maxPreviewItems)}
            </div>
            {!isCollapsedUsed && (
              <div className={styles.expandToggle}>
                <a href="" onClick={toggleExpanded}>
                  {expanded || isCollapsedUsed ? t('common:hideOthers') : t('common:showAll')}
                </a>
              </div>
            )}
          </>
        )}

        {/*
        {items.map(item => (
          <p key={item.slug}>
            <input type={multiselect ? 'checkbox' : 'radio'} name={type} id={`${type}-${item.slug}`} onClick={onSelect(item)} readOnly checked={selectedSlugs.includes(item.slug)} />
            <label htmlFor={`${type}-${item.slug}`}>{item.title} ({item.count})</label>
          </p>
        ))}
        */}
      </>
    </AggregationBox>
  );
};

FacetBox.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  multiselect: PropTypes.bool,
  items: PropTypes.oneOfType([
    PropTypes.shape({ [PropTypes.string]: PropTypes.number }),
    PropTypes.arrayOf(PropTypes.shape(aggItemPropTypes))
  ]),
  selected: PropTypes.arrayOf(PropTypes.shape(aggItemPropTypes)),
  searchItems: PropTypes.arrayOf(PropTypes.shape(itemPropTypes)),
  onSelect: PropTypes.func,
  maxPreviewItems: PropTypes.number,
  withSeoLinks: PropTypes.bool,
};

FacetBox.defaultProps = {
  type: '',
  title: '',
  multiselect: false,
  items: [],
  selected: [],
  searchItems: [],
  onSelect() {},
  maxPreviewItems: 5,
  withSeoLinks: false,
};

export default FacetBox;
